module.exports = __webpack_public_path__ + "img/sweep.992b4129.png";